"use client";

import { routes } from "@/lib/navigation/routes";
import { useParams, useSelectedLayoutSegments } from "next/navigation";
import { useWorkspaceNavigation } from "./use-workspace-navigation";

export type ProjectOwner =
  | { state: "loading" }
  | { state: "resolved"; projectId: string }
  | { state: "unknown" };

export type BreadcrumbDescriptor =
  | { type: "workspace"; href: string }
  | { type: "account" }
  | { type: "project"; owner: ProjectOwner }
  | { type: "app"; projectId: string; appId: string };

type RouteParams = {
  projectId?: string;
  appId?: string;
};

export function useBreadcrumbs(): BreadcrumbDescriptor[] {
  const workspace = useWorkspaceNavigation();
  const params = useParams<RouteParams>();
  const segments = useSelectedLayoutSegments();

  const workspaceHref = params.projectId
    ? routes.projects.list({ workspaceSlug: workspace.slug })
    : `/${workspace.slug}`;
  const crumbs: BreadcrumbDescriptor[] = [{ type: "workspace", href: workspaceHref }];
  if (segments[1] === "account") {
    crumbs.push({ type: "account" });
  }
  if (params.projectId) {
    crumbs.push({
      type: "project",
      owner: { state: "resolved", projectId: params.projectId },
    });
  }
  if (params.projectId && params.appId) {
    crumbs.push({ type: "app", projectId: params.projectId, appId: params.appId });
  }
  return crumbs;
}
